import { render, staticRenderFns } from "./MovieItem.vue?vue&type=template&id=4ef15aea&scoped=true&"
import script from "./MovieItem.vue?vue&type=script&lang=js&"
export * from "./MovieItem.vue?vue&type=script&lang=js&"
import style0 from "./MovieItem.vue?vue&type=style&index=0&id=4ef15aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef15aea",
  null
  
)

export default component.exports